import React from "react";
import { Star, Users } from "lucide-react";
import { useNavigate } from "react-router-dom";
import MagicalCard from "./MagicalCard";
import Avatar from "./Avatar";
import { EmptyState } from "./common";
import { useLang } from "../i18n";
import { RANK_STYLES } from "../utils";

export default function LeaderboardPanel({ entries = [], title, showViewAll = false, viewAllTo = "/ranking", compact = true }) {
  const { t, pick } = useLang();
  const navigate = useNavigate();
  return (
    <MagicalCard title={title || t("dash.weekly_leaders")} variant="ribbon-pink" testId="leaderboard-panel">
      {entries.length === 0 ? (
        <EmptyState icon="Trophy" title={t("lb.empty")} testId="leaderboard-empty" />
      ) : (
        <ul className="space-y-2.5">
          {entries.map((e) => {
            const style = RANK_STYLES[e.rank] || RANK_STYLES[5];
            return (
              <li key={e.student_id} data-testid={`leaderboard-entry-${e.rank}`}
                className={`flex items-center gap-3 rounded-2xl px-3 py-2.5 border transition-colors ${e.rank === 1 ? "bg-[#FFC83D]/10 border-[#FFC83D]/30" : "bg-[#0D0B38]/50 border-white/8 hover:border-white/20"}`}>
                <span className="w-9 h-9 rounded-full flex items-center justify-center font-black text-sm shrink-0"
                  style={{ background: style.bg, color: style.color, boxShadow: style.glow }}>
                  {e.rank}
                </span>
                <Avatar src={e.avatar} name={pick(e, "name")} size="sm" crown={e.rank === 1} />
                <span className="flex-1 font-extrabold text-sm truncate">{pick(e, "name")}</span>
                <span className="flex items-center gap-1 font-black text-[#FFC83D] text-sm whitespace-nowrap">
                  <Star className="w-4 h-4" fill="currentColor" />
                  {e.points}
                  <span className="text-[10px] text-[#A5A0D6] font-bold hidden sm:inline">{t("common.points")}</span>
                </span>
              </li>
            );
          })}
        </ul>
      )}
      {showViewAll && (
        <button data-testid="view-all-students-btn" onClick={() => navigate(viewAllTo)}
          className="mt-4 w-full btn-magic btn-ghost text-sm flex items-center justify-center gap-2">
          <Users className="w-4 h-4" /> {t("dash.view_all_students")}
        </button>
      )}
    </MagicalCard>
  );
}
